import React from 'react';
import { topFeatures, integrations } from '../data/mockData';
import { Settings, UserCheck, Headphones, Brain } from 'lucide-react';

const iconMap = {
  settings: Settings,
  'user-check': UserCheck,
  headphones: Headphones,
  brain: Brain,
};

const FeaturesSection = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1a1a2e]">
            Descubra Nossas Principais Funcionalidades
          </h2>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {topFeatures.map((feature) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div
                key={feature.id}
                className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-lg transition-shadow group"
              >
                <div className="w-14 h-14 bg-[#dbeafe] rounded-2xl flex items-center justify-center mb-4 group-hover:bg-[#3b82f6] transition-colors">
                  <IconComponent className="h-7 w-7 text-[#3b82f6] group-hover:text-white transition-colors" />
                </div>
                <h3 className="text-xl font-bold text-[#1a1a2e] mb-2">
                  {feature.title}
                </h3>
                <p className="text-gray-600">{feature.description}</p>
              </div>
            );
          })}
        </div>

        {/* Integrations */}
        <div className="bg-white rounded-2xl p-8 shadow-sm">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold text-[#1a1a2e] mb-2">
              Funciona com suas ferramentas
            </h3>
            <p className="text-gray-600">
              Use com CRMs, pagamentos e ferramentas de agendamento
            </p>
          </div>
          <div className="flex flex-wrap justify-center items-center gap-8">
            {integrations.map((integration) => (
              <div
                key={integration.name}
                className="flex flex-col items-center gap-2 group"
              >
                <div className="w-16 h-16 bg-gray-50 rounded-2xl flex items-center justify-center group-hover:bg-gray-100 transition-colors p-3">
                  <img
                    src={integration.logo}
                    alt={integration.name}
                    className="w-full h-full object-contain"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                  <div className="hidden w-full h-full items-center justify-center text-xl font-bold text-gray-400">
                    {integration.name[0]}
                  </div>
                </div>
                <span className="text-sm font-medium text-gray-700">
                  {integration.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
